const ProfilePageTranslations = {
  browse_all_galleries: 'Browse all author\'s galleries',
  see_all_models: 'See all {{modelCount}} 3D models',
  view_all_models: 'View all {{count}} models',
  reviews_title: 'Reviews',
  buyer_reviews_title: 'Reviews given',
  load_more: 'Load more',
  no_models_reviews: 'No 3D Model reviews yet.',
  no_projects_reviews: 'No 3D Project reviews yet.',
  no_artworks_uploaded: 'User has not uploaded any artworks yet',
  no_models_uploaded: 'User has not uploaded any 3D models yet.',
  no_tutorials_uploaded: 'User has not published any tutorials yet.',
  newest_label: 'Newest first',
  positive_label: 'Positive first',
  negative_label: 'Negative first',
  ratings: 'Ratings',
  avg_rating: 'Avg. rating',
  about: 'About',
  drag_cover_text: 'Drag to move Cover Image',
  reputation_points: 'Reputation Points',
  verified: `
    The CGT Standard ensures that 3D models meet high technical quality standards. Two status options,
    "N/A" and "Reviewed," are associated with this verification process. Once your model has been reviewed,
    you will receive a score. If needed, you can make improvements to the model and re-upload the updated
    files for another review with the potential for a higher score. Re-uploading improved model files
    may result in a faster review process since previous issues have already been addressed.
  `
}

export default ProfilePageTranslations
